import { tw } from 'utils/classnames'
import { TagBase } from './tag-base'

import type { TagBaseProps } from './tag-base'

export type TagStatusType = 'success' | 'error' | 'warning' | 'info' | 'neutral'
export type TagStatusVisualWeight = 'strong' | 'regular'

export interface TagStatusProps extends TagBaseProps {
  statusType?: TagStatusType
  visualWeight?: TagStatusVisualWeight
}

/* eslint-disable @stylistic/max-len */
const statusClasses: Record<string, string> = {
  success_strong:
    'bg-theme_semantic_status_success_background-color-strong ring-theme_semantic_status_success_border-color-strong text-theme_semantic_status_success_foreground-color-on-strong',
  success_regular:
    'bg-theme_semantic_status_success_background-color-regular ring-theme_semantic_status_success_border-color-regular text-theme_semantic_status_success_foreground-color-on-regular',
  error_strong:
    'bg-theme_semantic_status_error_background-color-strong ring-theme_semantic_status_error_border-color-strong text-theme_semantic_status_error_foreground-color-on-strong',
  error_regular:
    'bg-theme_semantic_status_error_background-color-regular ring-theme_semantic_status_error_border-color-regular text-theme_semantic_status_error_foreground-color-on-regular',
  warning_strong:
    'bg-theme_semantic_status_warning_background-color-strong ring-theme_semantic_status_warning_border-color-strong text-theme_semantic_status_warning_foreground-color-on-strong',
  warning_regular:
    'bg-theme_semantic_status_warning_background-color-regular ring-theme_semantic_status_warning_border-color-regular text-theme_semantic_status_warning_foreground-color-on-regular',
  info_strong:
    'bg-theme_semantic_status_info_background-color-strong ring-theme_semantic_status_info_border-color-strong text-theme_semantic_status_info_foreground-color-on-strong',
  info_regular:
    'bg-theme_semantic_status_info_background-color-regular ring-theme_semantic_status_info_border-color-regular text-theme_semantic_status_info_foreground-color-on-regular',
  neutral_strong:
    'bg-theme_semantic_status_neutral_background-color-neutral-strong ring-theme_semantic_status_neutral_border-color-neutral-strong text-theme_semantic_status_neutral_foreground-color-neutral-on-strong',
  neutral_regular:
    'bg-theme_semantic_status_neutral_background-color-neutral-regular ring-theme_semantic_status_neutral_border-color-neutral-regular text-theme_semantic_status_neutral_foreground-color-neutral-on-regular',
}
/* eslint-enable @stylistic/max-len */

/**
 * TagStatus -- a non-interactive display tag for status indicators.
 *
 * @example
 * ```tsx
 * <TagStatus statusType="success" visualWeight="strong">
 *   Active
 * </TagStatus>
 * ```
 *
 * @figma https://www.figma.com/design/wx3OX1hccLxomMLDn6QXDa/Studio-DS---Playground?node-id=2353-672
 */
export function TagStatus({
  statusType = 'success',
  visualWeight = 'strong',
  className,
  ...props
}: TagStatusProps) {
  const classes = statusClasses[`${statusType}_${visualWeight}`] ?? statusClasses.success_strong

  return <TagBase className={tw(classes, className)} {...props} />
}
